/**
 * The form every string comparison is made in: case, surrounding whitespace and
 * diacritics are all folded away before equality or containment is tested.
 *
 * Exported because a designer deciding whether two strings will compare equal has
 * to fold them exactly as evaluation will, or it refuses what the runtime honours.
 *
 * Explanation here on how macrons are normalized: https://stackoverflow.com/a/37511463
 */
export const standardizeString = (str: string) =>
  String(str)
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
